// extracted by mini-css-extract-plugin
module.exports = {"errorContainer":"index_errorContainer__DXnh1","title":"index_title__qVQRs","image":"index_image__2GnP1","maintenancePage":"index_maintenancePage__3s_QD"};